<app-standard-page>
  <div class="card vertical ms-0 container p-0">
    @if (registers) {
      <div class="body-container">
        <div class="card-body fs-4">
          <h1 class="text-primary">Get started</h1>
        </div>
      </div>
    } @else {
      <app-loading></app-loading>
    }
  </div>
</app-standard-page>
